import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Checkbox from "@material-ui/core/Checkbox";
import { withRedux, priceToDollars, getSortedDataToDisplay } from "helpers";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  formControl: {
    margin: theme.spacing(2),
  },
}));

function AdditionalOptionsItemsGroup(props) {
  const { group, selectedOptionsMap, cartItem } = props;

  const { maxOptions, isOptional, title, additionalOptionsItems, id } = group;

  const classes = useStyles();

  const [state, setState] = useState(selectedOptionsMap);
  const [error, setError] = useState("");

  const hasItemOptionsSelected = () => {
    return getItemOptionsCount() > 0;
  };

  const getItemOptionsCount = () => {
    return Object.values(state).filter((v) => v).length;
  };

  const validateChange = (isAddingOption) => {
    setError("");
    if (maxOptions === null && isOptional) return true;
    if (maxOptions === null && !isOptional) return true;
    if (isAddingOption) {
      if (getItemOptionsCount() >= maxOptions) {
        setError(
          "Maximum number of options (" + maxOptions + ") already selected."
        );
        window.setTimeout(() => {
          setError("");
        }, 2000);

        return false;
      }
    }
    return true;
  };

  const handleChange = (event) => {
    const isChangeValid = validateChange(event.target.checked);
    if (isChangeValid) {
      setState({ ...state, [event.target.name]: event.target.checked });
    }
  };

  useEffect(() => {
    updateGroupInCart();
  }, [state]);

  const groupIsInSelections = () => {
    return cartItem.additionalOptionSelections.some(
      (group) => group.additionalOptionsGroupId === id
    );
  };

  const addGroupToCartItem = () => {
    const { onCartItemChange } = props;
    const additionalOptionItemSelections = [];

    Object.keys(state).map(function (key) {
      const id = parseInt(key);
      if (state[key]) {
        additionalOptionItemSelections.push({
          selectedAdditionalItemId: id,
          quantity: 1,
        });
      }
    });

    cartItem.additionalOptionSelections.push({
      additionalOptionsGroupId: id,
      additionalOptionItemSelections,
    });
    onCartItemChange(cartItem);
  };

  const deleteGroupFromCartItem = () => {
    const { onCartItemChange } = props;
    const filtered = cartItem.additionalOptionSelections.filter((group) => {
      return group.additionalOptionsGroupId !== id;
    });
    cartItem.additionalOptionSelections = filtered;
    onCartItemChange(cartItem);
  };

  const updateGroupInCart = () => {
    if (hasItemOptionsSelected()) {
      if (!groupIsInSelections()) {
        addGroupToCartItem();
      } else {
        deleteGroupFromCartItem();
        addGroupToCartItem();
      }
    } else {
      deleteGroupFromCartItem();
    }
  };

  const renderOptionsItems = (items) => {
    if (!items || items.length === 0 || state == null) return null;
    const displayItems = getSortedDataToDisplay(items);
    return (
      <div style={{ width: "275px" }}>
        {displayItems.map((item, idx) => {
          if (item.retired) return null;
          // console.log(item.price);
          return (
            <div key={idx}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "16px",
                  alignItems: "center",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={state[item.id]}
                      onChange={handleChange}
                      name={item.id}
                    />
                  }
                  label={item.name}
                />
                {item.price != 0 && <p>+{priceToDollars(item.price)}</p>}
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  if (state == {}) return null;

  if (isOptional) {
    return (
      <div className={classes.root}>
        <FormControl
          component="fieldset"
          className={classes.formControl}
          error={error}
        >
          <FormGroup>{renderOptionsItems(additionalOptionsItems)}</FormGroup>
          <FormHelperText style={{ height: "1.66" }}>{error}</FormHelperText>
        </FormControl>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <FormControl
        required
        error={error}
        component="fieldset"
        className={classes.formControl}
      >
        <FormGroup>{renderOptionsItems(additionalOptionsItems)}</FormGroup>
        <FormHelperText style={{ height: "1.66" }}>{error}</FormHelperText>
      </FormControl>
    </div>
  );
}

export default withRedux(AdditionalOptionsItemsGroup);
